/**
 * Grouping helpers for the workspace switcher's rows.
 */

import { ORG_ENVIRONMENT, type WorkspaceGroup } from "@/frontend/types/org";
import type { Organization } from "@/server/schema/org";

/** Groups the org list into switcher rows, keyed by `workspaceGroupId` when paired and by org id otherwise. */
export function groupWorkspaces(organizations: Organization[]): WorkspaceGroup[] {
  const byKey = new Map<string, Organization[]>();
  for (const org of organizations) {
    const key = org.workspaceGroupId ?? org.id;
    const existing = byKey.get(key);
    if (existing) existing.push(org);
    else byKey.set(key, [org]);
  }

  const groups: WorkspaceGroup[] = [];
  for (const [key, members] of byKey) {
    const primary =
      members.find((member) => member.environment === ORG_ENVIRONMENT.PRODUCTION) ?? members[0];
    if (!primary) continue;
    groups.push({ key, members, primary, isPaired: members.length > 1 });
  }
  return groups;
}

/** The workspace a group opens on when none is chosen, its sandbox when it has one, else its only workspace. */
export function groupEntryWorkspace(group: WorkspaceGroup): Organization {
  return group.members.find((member) => member.environment === ORG_ENVIRONMENT.SANDBOX) ?? group.primary;
}
